import {
    FETCH_DASHBOARD_SUCCEESS,
    FETCH_DASHBOARD_TOKEN,
    FETCH_DASHBOARD_FAILED,
} from './actionsTypes';

export const fetchDashboardToken = () => {
    return {
        type: FETCH_DASHBOARD_TOKEN,
    };
};

export const fetchDashboardSuccess = (data) => {
    return {
        type: FETCH_DASHBOARD_SUCCEESS,
        payload: data,
    };
};

export const fetchDashboardFailed = (error) => {
    return {
        type: FETCH_DASHBOARD_FAILED,
        payload: error,
    };
};

export const fetchDashboard = (dashboardId) => {
    return (dispatch) => {
        dispatch(fetchDashboardToken());
        const { bradmanUserProfile } = JSON.parse(localStorage.getItem('user'));
        const { emailId } = bradmanUserProfile;
        const { facilityId, facilityName } = JSON.parse(
            localStorage.getItem('selectedFacility')
        );
        fetch(
            'https://wsp0klduck.execute-api.ap-southeast-1.amazonaws.com/stage-1/post-lambda',
            {
                method: 'POST',
                body: JSON.stringify({
                    email: 'pranjal.vora@jumbotail.com',
                    // get facality id and name from localstorage and pass it here
                    spaceId: facilityId,
                    spaceName: facilityName,
                    clientName: "Bradman",
                    collectionName: "SCM-Dashboards",
                    dashboardId
                }),
            }
        )
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data.body);
                dispatch(fetchDashboardSuccess(parsedData));
            })
            .catch((error) => {
                const errorMessage = error.message;
                dispatch(fetchDashboardFailed(true));
            });
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/dashboardActions.js